import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tower"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6.50851 21.4112C8.94594 18.187 10 10.7489 10 7H14C14 10.7489 15.0541 18.187 17.4915 21.4112C17.8137 21.766 18 22 18 22C17.8242 21.8242 17.6548 21.6272 17.4915 21.4112C16.4814 20.2991 14.135 18 12 18C9.86501 18 7.51863 20.2991 6.50851 21.4112C6.34525 21.6272 6.17578 21.8242 6 22C6 22 6.18625 21.766 6.50851 21.4112Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 3H15V7H9V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 2V3M12 3H9V7H15V3H12ZM9 22H5M15 22H19M17.5716 21.5C16.6103 20.427 14.1936 18 12 18C9.80383 18 7.38398 20.4327 6.425 21.5038M14 7C14 10.7837 15.0737 18.3256 17.5598 21.5M10 7C10 10.7837 8.92629 18.3256 6.44023 21.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Tower = Vue.extend<IconProps>({
  name: 'TowerIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tower',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Tower;
